import { Modal } from "react-bootstrap";

const HintModal = ({ points, show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="bg-primary text-center height-30 d-flex align-items-center">
        <h4 className="text-white mx-auto">Hints</h4>
      </Modal.Header>
      <Modal.Body className="px-3 py-1">
        {points.map((point, index) => (
          <div key={index} className="d-flex align-items-start" style={{ lineHeight: "2" }}>
            <p className="text-start p-r-5 font-weight-600">{index + 1}.</p>
            <p className="text-start" style={{ lineHeight: "2" }}>
              {point}
            </p>
          </div>
        ))}
      </Modal.Body>
    </Modal>
  );
};

export default HintModal;
